/**
 * @internal
 */
import { useState } from 'react';
export const mutableValuePlaceholder = (initialValue) => {
    return {
        set: () => null,
        get: () => initialValue,
        on: () => {
            // ensure an empty function is provided to prevent useEffect errors that no return function is provided
            return () => { };
        },
        destroy: () => null,
    };
};
export const mutableValue = (initialValue) => {
    let value = initialValue;
    let changeHandles = [];
    const addOnChange = (eventName, newHandle) => {
        changeHandles.push(newHandle);
        return () => {
            changeHandles = changeHandles.filter((handle) => handle !== newHandle);
        };
    };
    const handleSet = (newValue) => {
        if (value !== newValue) {
            value = newValue;
            changeHandles.forEach((handle) => handle(newValue));
        }
    };
    const handleGet = () => {
        return value;
    };
    const handleDestroy = () => {
        changeHandles = [];
    };
    return {
        set: handleSet,
        get: handleGet,
        on: addOnChange,
        destroy: handleDestroy,
    };
};
const useMutableValue = (initialValue) => {
    const [value] = useState(() => {
        return mutableValue(initialValue);
    });
    return value;
};
export default useMutableValue;
